<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Input]
 * Поле ввода
 */

// Components
import Button from "@/ui/button/button.vue";
// Icon
import CloseIcon from "@/ui/icons/close.vue";

// Types
import type { I_Input } from "./input.types.ts";

defineOptions({
    inheritAttrs: false,
});

const props = withDefaults(defineProps<Partial<I_Input>>(), {
    modelValue: "",
});

const emit = defineEmits<{
    (e: "update:modelValue", value: string): void;
}>();

function handleInput(event: Event) {
    const target = event.target as HTMLInputElement;
    emit("update:modelValue", target.value);
}

function clearInput() {
    emit("update:modelValue", "");
}
</script>

<template>
    <div class="tiw__input_with-icon">
        <input
            class="tiw__input"
            type="text"
            v-bind="$attrs"
            :value="props.modelValue"
            @input="handleInput"
        />
        <Button
            v-if="props.modelValue.length > 3"
            variant="unset"
            type="button"
            @click="clearInput"
        >
            <CloseIcon variant="basic" />
        </Button>
    </div>
</template>

<style lang="scss" src="./input.scss"></style>
